<template>
  <div class="anchorTaskWrap" :class="{scroll: from  === 'showset'}">
    <div class="boxTop">主播每周任务</div>
    <div class="boxBody">
      <div class="item" v-for="(v, k) in ApiList" :key="k">
        <img :src="v.anchorTaskConfigVO.headLogo"  class="td1 vatar"  alt="" srcset="">
       <!-- <el-image :src="v.anchorTaskConfigVO.headLogo" lazy class="td1 vatar" fit="cover">
          <div slot="placeholder" class="g_avatarError"></div>
          <div slot="error" class="g_avatarError"></div>
        </el-image> -->
        <div class="td2">
          <div class="p1 myfont1">{{ v.anchorTaskConfigVO.taskTitle }}</div>
          <div class="userprogress">
           <el-progress :text-inside="true" :stroke-width="6" class="el-bg-inner-running"
              :percentage="fifpercentage(v)"></el-progress>
          </div>
        </div>
        <div class="td3">           <div class="p2 u-flex">
              {{ v.anchorTaskConfigVO.remark }}
              <img class="hotIMgs" src="@/assets/img/hot.png" alt="" srcset="">
           </div>
          <!--                    <div class="p1" v-if="v.anchorTaskRecordVO.completeState === 1">已完成</div>
                    <div class="p1" v-else>未完成</div> -->
          <div class="p2">（{{ v.anchorTaskRecordVO.completeTarget }}/{{ v.anchorTaskConfigVO.taskTarget }}{{v.anchorTaskConfigVO.taskUnit}}）
          </div>
        </div>
      </div>
    </div>
    <div class="boxFoot">
      <div class="p1">主播任务说明</div>
      <div class="p2">
        1.每周完成对应任务后都会在下周开播时增加对应热度 <br>
        2.任务每周更新
      </div>
    </div>
  </div>
</template>
<script>
  import {
    getAnchorTask
  } from '@/api/lz.js'
  export default {
    props: ['itemValue', 'from','anchorId'],
    data() {
      return {
        ApiList: []
      }
    },
    methods: {
      fifpercentage(item){
        if(item){
          return Number((item.anchorTaskRecordVO.completeTarget / item.anchorTaskConfigVO.taskTarget) * 100)
        }
      },
      getList() {
        getAnchorTask({
          anchorId: this.anchorId
        }).then((res) => {
          if (res.data.code = 200) {
            console.log('主播任务列表', res.data.data);
            this.ApiList = res.data.data;
          }
        });
      },
      getUserInfo() {
        this.$store.dispatch('getUserInfoData', 2).then(async (result) => {
          console.log('获取用户信息', result, 2);
          // this.ApiDetail = result;
          // this.anchorId = result.userInfo.uid;
          this.getList();
        });
      },
    },
    mounted() {
      if(localStorage.getItem('token'));
      console.log('执行了两次');
      this.getList();
      // this.getUserInfo();
    },
    watch: {
      itemValue(val) {
        // console.log('test2',this.itemIndex, this.itemValue)
        // "taskId":'',// 任务ID
        // "completeState":0,// 任务完成状态，0：默认，未完成，1：已完成，奖励待领取，2：奖励已领取
        // "taskTarget":'', // 任务指标
        // "completeTarget": '',// 任务已完成的指标
        // "completeTimeSec":'', // 任务完成时间(秒值)
        // "touchTimeSec": '' // 任务触发的时间(秒值)
        let itemIndex = this.ApiList.findIndex(item=>item.anchorTaskConfigVO.taskId == val.taskId);
        console.warn('主播任务数据更新了。。。。。。。。。',val,itemIndex, this.ApiList[itemIndex]);
        if(itemIndex > -1){
          let curItem =  this.ApiList[itemIndex];
          curItem.anchorTaskRecordVO.completeState = val.completeState;
          curItem.anchorTaskRecordVO.taskTarget = val.taskTarget;
          curItem.anchorTaskRecordVO.completeTarget = val.completeTarget;
          curItem.anchorTaskRecordVO.completeTimeSec = val.completeTimeSec;
          curItem.anchorTaskRecordVO.touchTimeSec = val.touchTimeSec;
          this.$set(this.ApiList, itemIndex, curItem);
        }
      }
    }
  }
</script>
<style lang="scss">
  @import '../assets/style/flex.scss';

  .anchorTaskWrap {
    width: 350px;
    // height: 431px;
    background: #FFFFFF;
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);


    /* 渐变进度条 */
    .el-bg-inner-running .el-progress-bar__inner {
      background-color: unset;
      background: linear-gradient(90deg, #721EDC 0%, #721EDC 100%);
    }

    /*  */
    .personal-bottom-bottom-left .el-collapse-item__content {
      padding-bottom: 0px !important;
    }

    .el-bg-inner-running .el-progress-bar__innerText {
      color: rgba(0, 0, 0, 0);
    }


    .boxTop {
      height: 74px;
      background: url('~@/assets/img/home/img_task_title.png') no-repeat 50% 100%;
      background-size: 100% auto;
      text-indent: -9999px;
      overflow: hidden;
    }

    .boxBody {
      padding: 14px 12px;
      max-height: 320px;
      box-sizing: border-box;
      overflow-y: auto;
      overflow-x: hidden;

      .item {
        display: flex;
        justify-content: space-between;
        padding: 0 0 15px 0;
        font-size: 12px;

        .td1 {
          width: 38px;
          height: 38px;
          margin: 0 8px 0 0;
        }

        .td2 {
          display: flex;
          flex-direction: column;
          align-items: left;
          justify-content: space-between;
          flex: 2;
          box-sizing: border-box;
          .p1 {
            font-size: 14px;
            max-width: 154px;
            color: #333;
          }
          .userprogress{
            width: 130px;
            margin: 0 4px;
            border-radius: 2px;
          }

        }

        .td3 {
          min-width: 102px;
          text-align: right;
          display: flex;
          align-items: flex-end;
          flex-direction: column;
          justify-content: space-between;
          .hotIMgs{
            width: 10px;
            height: 11px;
          }
          .p2 {
            display: inline-block;
            color: #999;
            font-size: 12px;          }

          .p1 {
            width: 56px;
            text-align: center;
            height: 20px;
            background: #EEEBFF;
            border-radius: 10px;
            color: #A371E4;
            line-height: 20px;

            &.did {
              background: #F2F2F2;
              color: #666;
            }
          }
        }
      }
    }

    .boxFoot {
      padding: 0 12px 12px 12px;

      .p1 {
        font-size: 14px;
        font-weight: 500;
        line-height: 1em;
        height: 1em;
        margin: 0 0 6px 0;
        padding: 0 0 0 6px;
        border-left: 2px solid #721edc;
      }

      .p2 {
        line-height: 21px;
      }
    }

    &.scroll {
      .boxBody {
        height: auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AnchorTask.vue